import { render, staticRenderFns } from "./_base-bullet-info.vue?vue&type=template&id=5065c7b0"
import script from "./_base-bullet-info.vue?vue&type=script&lang=js"
export * from "./_base-bullet-info.vue?vue&type=script&lang=js"
import style0 from "./_base-bullet-info.vue?vue&type=style&index=0&id=5065c7b0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports